/**
 * Get Project Details Use Case
 *
 * Retrieves detailed information about a specific project.
 * This use case handles fetching project metadata, settings, and configuration.
 */

import type { IProjectsGateway } from "../ports/IProjectsGateway";
import type { ProjectDTO } from "../dtos/ProjectDTO";

export class GetProjectDetailsUseCase {
  constructor(private readonly projectsGateway: IProjectsGateway) {}

  async execute(projectId: string): Promise<ProjectDTO> {
    // Validate input
    if (!projectId || projectId.trim().length === 0) {
      throw new Error("Project ID is required");
    }

    return this.projectsGateway.getProjectDetails(projectId);
  }
}
